import { useLocation } from "react-router-dom";
import CarrouselTeam from "../components/carrouselTeam/carrouselTeam";

export default function CarrouselTeamPage() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const type= params.get("type");
  const sport= params.get("sport");
  const idEvent= params.get("idEvent");
  const momios = params.get("momios");
  const patrocinador = params.get("spon");
  const version= params.get("country");

  return (
    <CarrouselTeam flagMomios={momios} patrocinador={patrocinador} type={type} sport={sport} idEvent={idEvent} version={version}/>
  )

}